import { render, staticRenderFns } from "./table-search-simple.vue?vue&type=template&id=2abfa9c8&"
import script from "./table-search-simple.vue?vue&type=script&lang=js&"
export * from "./table-search-simple.vue?vue&type=script&lang=js&"
import style0 from "./table-search-simple.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports